import styled from "styled-components";
export default styled.button`
  appearance: none;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 18px;
  padding: 7px 30px;
  outline: none;

  &:hover {
    filter: brightness(110%);
  }
`;
